import initApp from '../../../../packages/springboard/platforms/offline-browser/platform_offline_browser_entrypoint.tsx';
import '../../../../src/entrypoints/browser_offline/browser_offline_springboard_entrypoint.ts';
export default initApp;
